import GlobalStyle from './global-style';
import theme from './theme';

export {
  GlobalStyle,
};

export default theme;
